export default __webpack_public_path__ + "static/media/scrollbar_decrement_light.96517c2c.svg";